var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { Slot } from "../../slot/Slot.js";
import { useCollapsibleContext } from "../Collapsible.context.js";
export const CollapsibleContent = forwardRef((_a, ref) => {
    var { children, asChild } = _a, rest = __rest(_a, ["children", "asChild"]);
    const ctx = useCollapsibleContext();
    const Comp = asChild ? Slot : "div";
    return (React.createElement(Comp, Object.assign({ ref: ref }, rest, { "data-state": ctx.state, hidden: !ctx.open, "aria-controls": ctx.open ? ctx.triggerId : undefined, id: ctx.contentId }), ctx.lazy || ctx.open ? children : null));
});
export default CollapsibleContent;
//# sourceMappingURL=Collapsible.Content.js.map